"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShareIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.629 5.027c-.468 0-.903-.144-1.27-.392L6.648 7.38a2.654 2.654 0 010 1.386l3.609 2.67a2.27 2.27 0 011.371-.463c1.31 0 2.371 1.125 2.371 2.513C14 14.875 12.938 16 11.629 16c-1.31 0-2.37-1.125-2.37-2.514 0-.183.018-.361.053-.534l-3.7-2.738a2.261 2.261 0 01-1.241.372C3.061 10.586 2 9.461 2 8.073s1.062-2.514 2.371-2.514c.455 0 .88.137 1.242.372l3.728-2.76a2.658 2.658 0 01-.083-.657C9.258 1.125 10.32 0 11.63 0 12.939 0 14 1.125 14 2.514c0 1.388-1.062 2.513-2.371 2.513z"
  })))
});
ShareIcon.displayName = 'ShareIcon';
var _default = exports.default = ShareIcon;